<template>
  <l-layout :layout="['xs12']">
    <v-card class="pa-3">
      <v-form ref="ruleForm">
        <v-card class="pa-3">
          <v-card-title>
            <h3>基本信息</h3>
            <v-btn color="primary" flat class="pt-1" @click="status='edit'" v-if="status==='readonly'">修改</v-btn>
          </v-card-title>
          <v-layout column>
            <v-layout>
              <v-flex xs6>
                <v-text-field label="规则名称" prepend-icon="$vuetify.icons.title" v-model="form.name"
                              :readonly="status==='readonly'" :rules="[$rules.requiredS()]">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :readonly="status==='readonly'"
                  :items="form.orgSelect"
                  v-model="form.org"
                  v-on:keyup="getOrgs"
                  prepend-icon="$vuetify.icons.org"
                  label="所属分组"
                  clearable
                  hide-details
                  hide-selected
                  item-text="name"
                  item-value="id"
                  :rules="[$rules.requiredS('必填')]"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="error">
                      暂无该分组信息
                    </v-alert>
                  </template>
                  <template slot="item" slot-scope="props">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <v-flex row align-center justify-between>
                          <span>{{props.item.name}}</span>
                        </v-flex>
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <!--<span class="grey&#45;&#45;text caption text-xs-right">{{props.item.loginId}}</span>-->
                    </v-list-tile-action>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-select label="规则类型" :items="form.typeSelect" item-text="label" :readonly="status==='readonly'"
                          item-value="value" prepend-icon="$vuetify.icons.location" v-model="form.ruleType" :rules="[$rules.requiredS()]">
                </v-select>
              </v-flex>
              <v-flex xs6>
                <v-select label="超出单位时长部分计费分类" :items="form.utiExCtSelect" v-model="form.utiExCt" prepend-icon="$vuetify.icons.info"
                item-text="name" item-value="value" :rules="[$rules.requiredS()]"></v-select>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card>
        <v-card class="pa-3 mt-3" v-if="form.ruleType==='simpleRule'">
          <v-card-title>
            <h3>规则模板选择</h3>
          </v-card-title>
          <v-layout column>
            <v-layout>
              <v-flex xs6>
                <v-autocomplete
                  :readonly="status==='readonly'"
                  :items="form.ruleTemplateSelect"
                  v-model="form.ruleTemplate"
                  v-on:keyup="getTemplate"
                  prepend-icon="$vuetify.icons.title"
                  label="模板选择"
                  clearable
                  hide-details
                  hide-selected
                  item-text="name"
                  item-value="id"
                  :rules="[$rules.requiredS('必填')]"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="error">
                      暂无模板信息
                    </v-alert>
                  </template>
                  <template slot="item" slot-scope="props">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <v-flex row align-center justify-between>
                          <span>{{props.item.name}}</span>
                        </v-flex>
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <!--<span class="grey&#45;&#45;text caption text-xs-right">{{props.item.loginId}}</span>-->
                    </v-list-tile-action>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card>
        <v-card class="pa-3 mt-3" v-if="form.ruleType==='simpleRule'&&form.ruleTemplate!==''">
          <v-card-title>
            <h3>常量参数配置</h3>
          </v-card-title>
          <v-layout column>
            <v-layout v-for="(p,index) in form.constantParams" :key="index">
              <v-flex xs5>
                <v-text-field label="参数描述" v-model="p.desc" prepend-icon="$vuetify.icons.code" readonly :rules="[$rules.requiredS()]">
                </v-text-field>
              </v-flex>
              <v-flex xs7>
                <v-text-field label="参数配置" v-model="p.value" prepend-icon="$vuetify.icons.comment" :readonly="status==='readonly'" v-if="p.type==='string'" :rules="[$rules.requiredS()]">
                </v-text-field>
                <v-text-field label="参数配置" v-model="p.value" prepend-icon="$vuetify.icons.comment" :readonly="status==='readonly'" v-if="p.type==='int'" :rules="[$rules.requiredNum()]">
                </v-text-field>
                <v-radio-group v-model="p.value" v-if="p.type==='boolean'" label="参数配置" row :rules="[$rules.requiredS()]">
                  <v-radio
                    :label="'true'"
                    :value="true"
                  ></v-radio>
                  <v-radio
                    :label="'false'"
                    :value="false"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card>
       <!-- <v-card class="pa-3 mt-3" v-if="form.ruleType==='simpleRule'&&form.ruleTemplate!==''">
          <v-card-title>
            <h3>变量参数配置</h3>
          </v-card-title>
          <v-layout column>
            <v-layout v-for="(p,index) in form.variableParams" :key="index">
              <v-flex xs5>
                <v-text-field label="参数描述" v-model="p.desc" prepend-icon="$vuetify.icons.code" readonly :rules="[$rules.requiredS()]">
                </v-text-field>
              </v-flex>
              <v-flex xs7>
                <v-text-field label="参数配置" v-model="p.value" prepend-icon="$vuetify.icons.comment" :readonly="status==='readonly'" v-if="p.type==='string'" :rules="[$rules.requiredS()]">
                </v-text-field>
                <v-radio-group v-model="p.value" label="参数配置" v-if="p.type==='boolean'" :rules="[$rules.requiredS()]"
                               :readonly="status==='readonly'" row prepend-icon="$vuetify.icons.lock">
                  <v-radio
                    :label="'true'"
                    :value="true"
                  ></v-radio>
                  <v-radio
                    :label="'false'"
                    :value="false"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card>-->
        <v-card class="pa-3 mt-3" v-if="form.ruleType==='periodRule'">
          <v-card-title>
            <h3>周期属性配置</h3>
          </v-card-title>
          <v-layout column>
            <v-layout>
              <v-flex xs6>
                <v-select label="周期计费规则类型" prepend-icon="$vuetify.icons.location" v-model="form.periodType" :items="form.periodTypeSelect"
                          :readonly="status==='readonly'" :rules="[$rules.requiredS()]"
                item-text="name" item-value="value">
                </v-select>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card>
        <v-form ref="periodForm">
        <v-card class="pa-3 mt-3" v-if="form.ruleType==='periodRule'">
          <v-card-title>
            <h3>周期分段配置</h3>
            <span>
              <v-btn flat color="primary" @click="addPeriod">添加</v-btn>
            </span>
          </v-card-title>
          <v-layout column class="pl-3" v-for="(p,index) in form.period" :key="index" justify-center>
            <v-card class="mt-2">
              <v-card-title>
                <h4>分段{{index+1}}</h4>
                <v-spacer></v-spacer>
                <v-btn icon @click="deletePeriod(index)">
                  <v-icon>{{$vuetify.icons.close}}</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider></v-divider>
                <v-flex xs12 class="pl-3 pr-3">
                  <v-layout column>
                    <v-layout align-center justify-start>
                      <v-flex xs6 v-if="form.periodType==='perWeek'">
                        <v-select :items="daySelect" prepend-icon="$vuetify.icons.date" label="开始时间" v-model="p.stDay"
                                  :rules="[$periodCheck.stTimeRule(p),$periodCheck.haveMutiplePeriod(form.period,p),$rules.requiredS()]"></v-select>
                      </v-flex>
                      <span class="mx-2" v-if="form.periodType==='perWeek'"> </span>
                      <v-flex xs6>
                        <v-select :items="hourSelect" suffix="时" :label="hourStartLabel" :prepend-icon="hourIcon" v-model="p.stHour"
                                  :rules="[$periodCheck.stTimeRule(p),$periodCheck.haveMutiplePeriod(form.period,p),$rules.requiredS()]"></v-select>
                      </v-flex>
                      <span class="mx-2">:</span>
                      <v-flex xs3>
                        <v-select :items="minuteSelect" suffix="分" v-model="p.stMinute" :rules="[$periodCheck.stTimeRule(p),$periodCheck.haveMutiplePeriod(form.period,p),$rules.requiredS()]"></v-select>

                      </v-flex>
                      <span class="mx-2">:</span>
                      <v-flex xs3>
                        <v-select :items="secondSelect" suffix="秒" v-model="p.stSecond" :rules="[$periodCheck.stTimeRule(p),$periodCheck.haveMutiplePeriod(form.period,p),$rules.requiredS()]"></v-select>
                      </v-flex>
                    </v-layout>
                    <v-layout align-center justify-start>
                      <v-flex xs6 v-if="form.periodType==='perWeek'">
                        <v-select :items="daySelect" prepend-icon="$vuetify.icons.date" label="结束时间" v-model="p.edDay"
                                  :rules="[$periodCheck.edTimeRule(p),$periodCheck.haveMutiplePeriod(form.period,p),$rules.requiredS()]"></v-select>
                      </v-flex>
                      <span class="mx-2" v-if="form.periodType==='perWeek'"> </span>
                      <v-flex xs6>
                        <v-select :items="hourSelect" suffix="时" :label="hourEndLabel" :prepend-icon="hourIcon" v-model="p.edHour"
                                  :rules="[$periodCheck.edTimeRule(p),$periodCheck.haveMutiplePeriod(form.period,p),$rules.requiredS()]"></v-select>
                      </v-flex>
                      <span class="mx-2">:</span>
                      <v-flex xs3>
                        <v-select :items="minuteSelect" suffix="分" v-model="p.edMinute"  :rules="[$periodCheck.edTimeRule(p),$periodCheck.haveMutiplePeriod(form.period,p),$rules.requiredS()]"></v-select>
                      </v-flex>
                      <span class="mx-2">:</span>
                      <v-flex xs3 >
                        <v-select :items="secondSelect" suffix="秒" v-model="p.edSecond"  :rules="[$periodCheck.edTimeRule(p),$periodCheck.haveMutiplePeriod(form.period,p),$rules.requiredS()]"></v-select>
                      </v-flex>
                    </v-layout>
                    <v-layout class="mb-5">
                      <v-autocomplete
                        :readonly="status==='readonly'"
                        :items="p.ruleSelect"
                        v-model="p.rule"
                        v-on:keyup="findRulesInGroup(p.search,index)"
                        :search-input.sync="p.search"
                        prepend-icon="$vuetify.icons.code"
                        label="计费规则"
                        clearable
                        hide-details
                        hide-selected
                        item-text="name"
                        item-value="id"
                        :rules="[$rules.requiredS('必填')]"
                      >
                        <template slot="no-data">
                          <v-alert :value="true" color="error">
                            暂无规则信息
                          </v-alert>
                        </template>
                        <template slot="item" slot-scope="props">
                          <v-list-tile-content>
                            <v-list-tile-title>
                              <v-flex row align-center justify-between>
                                <span>{{props.item.name}}</span>
                              </v-flex>
                            </v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <!--<span class="grey&#45;&#45;text caption text-xs-right">{{props.item.loginId}}</span>-->
                          </v-list-tile-action>
                        </template>
                      </v-autocomplete>
                    </v-layout>
                  </v-layout>
                </v-flex>
            </v-card>
          </v-layout>
          <v-layout justify-center class="mt-2">
            <v-btn icon @click="addPeriod" :disabled="status==='readonly'">
              <v-icon color="primary">
                {{$vuetify.icons.add}}
              </v-icon>
            </v-btn>
          </v-layout>
        </v-card>
        </v-form>
        <v-layout justify-center>
          <v-btn class="primary" :loading="loading" :disabled="status==='readonly'" @click="(status==='new')?submitSimpleRule():updateSimpleRule()" v-if="form.ruleType==='simpleRule'">提交</v-btn>
          <v-btn class="primary" :loading="loading" :disabled="status==='readonly'" @click="(status==='new')?submitPeriodRule():updatePeriodRule()" v-if="form.ruleType==='periodRule'">提交</v-btn>
        </v-layout>
      </v-form>
    </v-card>
  </l-layout>
</template>
<script>
import LSelectDatetime from '../../../ladmin/components/LSelectDatetime/LSelectDatetime'
import {PassRule} from '../../../object'
import periodCheck from './periodCheck'
export default{
  name: 'ruleConfig',
  components: {LSelectDatetime},
  props: {
    statusProp: {
      type: String,
      default: 'new'
    },
    typeProp: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    daySelect () {
      return ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天']
    },
    hourSelect () {
      let times = []
      for (let i = 0; i <= 24; i++) {
        if (i < 10) {
          times.push('0' + i)
        }
        else {
          times.push(i + '')
        }
      }
      return times
    },
    minuteSelect () {
      let times = []
      for (let i = 0; i <= 60; i++) {
        if (i < 10) {
          times.push('0' + i)
        }
        else {
          times.push(i + '')
        }
      }
      return times
    },
    secondSelect () {
      let times = []
      for (let i = 0; i <= 60; i++) {
        if (i < 10) {
          times.push('0' + i)
        }
        else {
          times.push(i + '')
        }
      }
      return times
    },
    hourStartLabel () {
      if (this.form.periodType === 'perDay') {
        return '开始时间'
      }
      else {
        return ''
      }
    },
    hourEndLabel () {
      if (this.form.periodType === 'perDay') {
        return '结束时间'
      }
      else {
        return ''
      }
    },
    hourIcon () {
      if (this.form.periodType === 'perDay') {
        return '$vuetify.icons.date'
      }
      else {
        return ''
      }
    }
  },
  data () {
    return {
      loading: false,
      form: {
        name: '',
        org: '',
        orgSelect: [],
        ruleType: '',
        typeSelect: [
          {label: '简单计费规则', value: 'simpleRule'},
          {label: '周期计费规则', value: 'periodRule'}
        ],
        constantParams: [
        ],
        variableParams: [
        ],
        periodType: '',
        periodTypeSelect: [
          {name: '自然天', value: 'perDay'},
          {name: '自然周', value: 'perWeek'}
        ],
        period: [],
        ruleTemplate: '',
        ruleTemplateSelect: [],
        ruleSelect: [],
        utiExCt: '',
        utiExCtSelect: [
          {name: '不满单位时长，免费', value: '1'},
          {name: '不满单位时长，按单位时长计算', value: '2'},
          {name: '不满单位时长，超出时长/单位时长，小于0.5免费，否则按单位时长计费', value: '3'}
        ],
      },
      status: '',
    }
  },
  created () {
    this.initViewProp()
    this.initFormData()
  },
  methods: {
    initViewProp () {
      if (this.$route.query.status !== undefined) {
        this.status = this.$route.query.status
      }
      else {
        this.status = this.statusProp
      }
    },
    initFormData () {
      if (this.status === 'new') {
        return
      }
      // console.log(this.formData)
      this.form.name = this.formData.name
      this.form.ruleType = (this.typeProp === 'simple') ? 'simpleRule' : 'periodRule'
      this.initOrg(this.formData.obgrpId)
      if (this.form.ruleType === 'simpleRule') {
        this.initSimpleRuleData()
      }
      else {
        this.initPeriodRuleData()
      }
    },
    initSimpleRuleData () {
      let extend = JSON.parse(this.formData.extend)
      this.form.utiExCt = extend.utiExCt + ''
      this.initRuleTemplate()
    },
    initPeriodRuleData () {
      console.log(this.formData)
      let attributes = JSON.parse(this.formData.attributes)
      this.form.periodType = (attributes.cp === 10080) ? 'perWeek' : 'perDay'
      this.form.utiExCt = attributes.utiExCt
      this.initSections(this.formData.sections)
    },
    async initSections () {
      let sections = JSON.parse(this.formData.sections)
      for (let i = 0; i < sections.length; i++) {
        let obj = {
          stDay: '星期一',
          stHour: '00',
          stMinute: '00',
          stSecond: '00',
          edDay: '星期一',
          edHour: '00',
          edMinute: '00',
          edSecond: '00',
          rule: '',
          ruleSelect: [],
          ruleTmp: '',
          search: ''
        }
        let section = sections[i]
        obj.ruleTmp = section.crId
        let pagination = {page: 1, rowsPerPage: 10}
        let {items} = await this.$store.dispatch('charging/getRuleConfigList', {pagination, search: {key: 'id', value: section.ccId}})
        obj.rule = items[0]
        obj.ruleSelect.push(items[0])
        if (this.form.periodType === 'perDay') {
          obj.stHour = section.st.substr(0, 2)
          obj.edHour = section.et.substr(0, 2)
          obj.stMinute = section.st.substr(3, 2)
          obj.edMinute = section.et.substr(6, 2)
          obj.stSecond = section.st.substr(6, 2)
          obj.edSecond = section.et.substr(6, 2)
        }
        else {
          obj.stDay = section.st.substr(0, 3)
          obj.edDay = section.et.substr(0, 3)
          obj.stHour = section.st.substr(4, 2)
          obj.edHour = section.et.substr(4, 2)
          obj.stMinute = section.st.substr(7, 2)
          obj.edMinute = section.et.substr(7, 2)
          obj.stSecond = section.st.substr(10, 2)
          obj.edSecond = section.et.substr(10, 2)
        }
        this.form.period.push(obj)
      }
    },
    getUserInfo () {
      return JSON.parse(sessionStorage.getItem('loginInfo'))
    },
    addPeriod () {
      let obj = {
        stDay: '星期一',
        stHour: '00',
        stMinute: '00',
        stSecond: '00',
        edDay: '星期一',
        edHour: '00',
        edMinute: '00',
        edSecond: '00',
        rule: '',
        ruleSelect: [],
        ruleTmp: '',
        search: ''
      }
      this.form.period.push(obj)
    },
    deletePeriod (index) {
      this.form.period.splice(index, 1)
    },
    initRuleTemplate () {
      this.form.ruleTemplateSelect = []
      this.form.ruleTemplateSelect.push(this.formData.ruleTmplt)
      this.form.ruleTemplate = this.formData.ruleTmplt
    },
    initParamData () {
      let constantParams = JSON.parse(this.formData.constantParams)
      for (let p in constantParams) {
        for (let i = 0; i < this.form.constantParams.length; i++) {
          if (this.form.constantParams[i].key === p + '') {
            this.form.constantParams[i].value = constantParams[p]
          }
        }
      }
    },
    async initOrg (id) {
      let res = await this.$store.dispatch('charging/getOrgs', {name: '', id: id})
      if (res.data.status === 1) {
        this.form.orgSelect = res.data.data.content
        this.form.org = res.data.data.content[0]
      }
      else {
        this.form.orgSelect = []
      }
    },
    async getOrgs (data) {
      let search = (data === undefined) ? '' : data.target.value
      let res = await this.$store.dispatch('charging/getOrgs', {name: search, id: ''})
      if (res.data.status === 1) {
        this.form.orgSelect = res.data.data.content
      }
      else {
        this.form.orgSelect = []
      }
    },
    async findRulesInGroup (data, index) {
      let pagination = {page: 1, rowsPerPage: 10}
      let {items} = await this.$store.dispatch('charging/getRuleConfigList', {pagination, filter: [{key: 'obgrpId', value: this.form.org}], search: {key: 'name', value: data}})
      this.form.period[index].ruleSelect = items
    },
    async getTemplate (data) {
      let search = (data === undefined) ? '' : data.target.value
      // console.log(this.form.org)
      let filter = [{key: 'obgrpId', value: this.form.org}]
      let res = await this.$store.dispatch('charging/getRuleTemplateList', {pagination: {page: 1, rowsPerPage: 10}, filter: filter, search: {key: 'name', value: search}})
      this.form.ruleTemplateSelect = res.items
    },
    async getTemplateInfo () {
      let templateId = (this.form.ruleTemplate instanceof Object) ? this.form.ruleTemplate.id : this.form.ruleTemplate
      let res = await this.$store.dispatch('charging/getRuleTemplateList', {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: templateId}})
      if (res.items.length === 0) {}
      else {
        this.dealConstantParams(res.items[0].constantParamDefinitions)
      }
    },
    dealConstantParams (data) {
      let constantParams = JSON.parse(data)
      for (let p in constantParams) {
        let item = constantParams[p]
        item.value = ''
        item.key = p
        this.form.constantParams.push(item)
      }
      if (this.status === 'readonly') {
        this.initParamData()
      }
    },
    async submitSimpleRule () {
      if (!this.$refs.ruleForm.validate()) {
        this.$L.alert('error', {message: '表单数据不合法'})
        return
      }
      let constantParams = {}
      for (let i = 0; i < this.form.constantParams.length; i++) {
        let item = this.form.constantParams[i]
        constantParams[item.key] = item.value
      }
      let params = {
        'name': this.form.name,
        'obgrpId': (this.form.org instanceof Object) ? this.form.org.id : this.form.org,
        'constantParams': constantParams,
        'utiExCt': this.form.utiExCt,
        'creator': this.getUserInfo().name,
        'ruleTmpltId': (this.form.ruleTemplate instanceof Object) ? this.form.ruleTemplate.id : this.form.ruleTemplate
      }
      let res = await this.$store.dispatch('charging/addSimpleRule', params)
      if (res.data.status + '' === '200') {
        this.$L.alert('success', {message: '添加成功'})
        this.status = 'readonly'
      }
      else {
        this.$L.alert('error', {message: '添加失败，原因：' + res.data.msg})
      }
    },
    async updateSimpleRule () {
      if (!this.$refs.ruleForm.validate()) {
        this.$L.alert('error', {message: '表单数据不合法'})
        return
      }
      let constantParams = {}
      for (let i = 0; i < this.form.constantParams.length; i++) {
        let item = this.form.constantParams[i]
        constantParams[item.key] = item.value
      }
      let params = {
        'id': this.formData.id,
        'name': this.form.name,
        'obgrpId': (this.form.org instanceof Object) ? this.form.org.id : this.form.org,
        'constantParams': constantParams,
        'utiExCt': this.form.utiExCt,
        'lastEditor': this.getUserInfo().name,
        'ruleTmpltId': (this.form.ruleTemplate instanceof Object) ? this.form.ruleTemplate.id : this.form.ruleTemplate
      }
      let res = await this.$store.dispatch('charging/updateSimpleRule', params)
      if (res.data.status + '' === '200') {
        this.$L.alert('success', {message: '更新成功'})
        this.status = 'readonly'
      }
      else {
        this.$L.alert('error', {message: '添加失败，原因：' + res.data.msg})
      }
    },
    async submitPeriodRule () {
      if (!this.$refs.ruleForm.validate()) {
        this.$L.alert('error', {message: '表单数据不合法'})
        return
      }
      if (this.form.periodType === 'perDay' && !this.$periodCheck.checkPerDay(this.form.period)) {
        this.$L.alert('error', {message: '已配置的周期时间不足一天，请重新配置时间周期'})
        return
      }
      if (this.form.periodType === 'perWeek' && !this.$periodCheck.checkPerWeek(this.form.period)) {
        this.$L.alert('error', {message: '已配置的周期时间不足一周，请重新配置时间周期'})
        return
      }
      let sections = []
      for (let i = 0; i < this.form.period.length; i++) {
        let {items} = await this.$store.dispatch('charging/getRuleConfigList', {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: this.form.period[i].rule}})
        console.log(items)
        this.form.period[i].ruleTmp = items[0].ruleTmplt.id
        let item = this.form.period[i]
        let section = {
          'secId': i,
          'st': (this.form.periodType === 'perDay') ? item.stHour + ':' + item.stMinute + ':' + item.stSecond : item.stDay + ' ' + item.stHour + ':' + item.stMinute + ':' + item.stSecond,
          'et': (this.form.periodType === 'perDay') ? item.edHour + ':' + item.edMinute + ':' + item.edSecond : item.edDay + ' ' + item.edHour + ':' + item.edMinute + ':' + item.edSecond,
          'crId': item.ruleTmp,
          'ccId': item.rule
        }
        sections.push(section)
      }
      let params = {
        'name': this.form.name,
        'obgrpId': this.form.org,
        'attributes': {
          'cp': (this.form.periodType === 'perDay') ? 1440 : 10080,
          'secAm': this.form.period.length,
          'utiExCt': this.form.utiExCt
        },
        'sections': sections,
        'creator': this.getUserInfo().name
      }
      this.loading = true
      let res = await this.$store.dispatch('charging/addPeriodRule', params)
      this.loading = false
      if (res.data.status + '' === '200') {
        this.$L.alert('success', {message: '添加成功'})
        this.status = 'readonly'
      }
      else {
        this.$L.alert('error', {message: '添加失败，原因:' + res.data.msg})
      }
    },
    async updatePeriodRule () {
      if (!this.$refs.ruleForm.validate()) {
        this.$L.alert('error', {message: '表单数据不合法'})
        return
      }
      if (this.form.periodType === 'perDay' && !this.$periodCheck.checkPerDay(this.form.period)) {
        this.$L.alert('error', {message: '已配置的周期时间不足一天，请重新配置时间周期'})
        return
      }
      if (this.form.periodType === 'perWeek' && !this.$periodCheck.checkPerWeek(this.form.period)) {
        this.$L.alert('error', {message: '已配置的周期时间不足一周，请重新配置时间周期'})
        return
      }
      let sections = []
      for (let i = 0; i < this.form.period.length; i++) {
        let {items} = await this.$store.dispatch('charging/getRuleConfigList',
          {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: this.form.period[i].rule instanceof Object ? this.form.period[i].rule.id : this.form.period[i].rule}})
        this.form.period[i].ruleTmp = items[0].ruleTmplt.id
        let item = this.form.period[i]
        let section = {
          'secId': i,
          'st': (this.form.periodType === 'perDay') ? item.stHour + ':' + item.stMinute + ':' + item.stSecond : item.stDay + ' ' + item.stHour + ':' + item.stMinute + ':' + item.stSecond,
          'et': (this.form.periodType === 'perDay') ? item.edHour + ':' + item.edMinute + ':' + item.edSecond : item.edDay + ' ' + item.edHour + ':' + item.edMinute + ':' + item.edSecond,
          'crId': item.ruleTmp,
          'ccId': item.rule instanceof Object ? item.rule.id : item.rule
        }
        sections.push(section)
      }
      let params = {
        'id': this.formData.id,
        'name': this.form.name,
        'obgrpId': this.form.org,
        'attributes': {
          'cp': (this.form.periodType === 'perDay') ? 1440 : 10080,
          'secAm': this.form.period.length,
          'utiExCt': this.form.utiExCt
        },
        'sections': sections,
        'lastEditor': this.getUserInfo().name
      }
      this.loading = true
      let res = await this.$store.dispatch('charging/updatePeriodRule', params)
      this.loading = false
      if (res.data.status + '' === '200') {
        this.$L.alert('success', {message: '更新成功'})
        this.status = 'readonly'
      }
      else {
        this.$L.alert('error', {message: '添加失败，原因:' + res.data.msg})
      }
    }
  },
  watch: {
    'form.org' (val, oldVal) {
      if (oldVal === '') {
        return
      }
      this.form.ruleTemplate = ''
    },
    'form.ruleTemplate' () {
      this.getTemplateInfo()
    },
    'form.periodType' () {
      this.form.period = []
    },
    'form.period': {
      handler (val, oldVal) {
        // console.log(this.form.period)
        this.$refs.periodForm.validate()
      },
      deep: true
    }
  }
}
</script>
